"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appConfigContextDefaultValue = exports.appConfigContext = exports.AppConfigProvider = void 0;
var _react = require("react");
const appConfigContextDefaultValue = exports.appConfigContextDefaultValue = {
  isFrontPage: false,
  isStandalone: false,
  showFooterOnDesktop: false
};
const appConfigContext = exports.appConfigContext = /*#__PURE__*/(0, _react.createContext)(appConfigContextDefaultValue);
const AppConfigProvider = exports.AppConfigProvider = appConfigContext.Provider;